goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$sync_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content_actions$sync_svg");
shadow.js.shim.module$src$svg$wpp$content_actions$sync_svg = shadow.js.nativeProvides["src/svg/wpp/content-actions/sync.svg"] = shadow$bridge("src/svg/wpp/content-actions/sync.svg");
module$shadow_js_shim_module$src$svg$wpp$content_actions$sync_svg.default = shadow.js.shim.module$src$svg$wpp$content_actions$sync_svg;
